import { render, staticRenderFns } from "./MonthSlotGeneric.vue?vue&type=template&id=6bc0abbd&"
import script from "./MonthSlotGeneric.vue?vue&type=script&lang=ts&"
export * from "./MonthSlotGeneric.vue?vue&type=script&lang=ts&"
import style0 from "./MonthSlotGeneric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports